const PrecisionRound = (number, precision = 1) => {
  let factor = Math.pow(10, precision)
  return Math.round(number * factor) / factor
}

export default PrecisionRound



// WEBPACK FOOTER //
// ./src/Utils/PrecisionRound.js